import { FC } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { CSSProperties, useRef } from "react";

import ErrorImage from "./assets/blank.png";

export interface ImageProps {
  src?: string;
  alt?: string;
  className?: string;
  bordered?: boolean;
  style?: CSSProperties;
}

export const Image: FC<ImageProps> = ({
  src,
  alt,
  className,
  bordered,
  style,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);

  const handleLoadImageError = () => {
    if (imageRef.current) imageRef.current.src = ErrorImage;
  };
  return (
    <img
      src={src}
      alt={alt || "img"}
      ref={imageRef}
      onError={handleLoadImageError}
      className={clsx(styles.root, bordered && styles.bordered, className)}
      style={style}
    />
  );
};
